import { AppDocumentos } from '../../../core/models/appDocumentos.model';
import { AppDocumentosService } from '../../../core/services/appDocumentos.service';
import { AppA3DocDocument } from '../../../core/models/appA3DocDocument.model';
import { AppA3DocService } from '../../../core/services/appA3Doc.service';
import { HttpParams } from '@angular/common/http';
import { AfterContentChecked, AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';


@Component({
  selector: 'app-documentos-list',
  templateUrl: './documentos-list.component.html',
  styleUrls: ['./documentos-list.component.scss'],
  providers: [AppDocumentosService, AppA3DocService]
})
export class DocumentosListComponent extends ListFormBase<AppDocumentos> implements AfterViewInit {
  // Propiedades del panel contenedor
  panelIcon = 'description'; // Material icon
  panelTitle = 'Documentos';
  panelDescription = 'Listado de los documentos dado un entorno';
  loading: boolean = false;
  selectedHeaderFilter: string[] = [];
  allDocuments: any[] = [];
  dataSource: any[] = [];
  selectedRows = [];
  companySelected;
  @ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

  constructor(
    protected _modelService: AppDocumentosService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    private appA3DocService: AppA3DocService,
    private cdr: ChangeDetectorRef
  ) {
    super(_modelService, _router, _route, _messageDialog, AppDocumentos);
    this.isCrud = true;
  }

  ngAfterViewInit(): void {

  }


  companySelectedChanged(data: any) {
    this.companySelected = data[0].nif;
    this.loading = true;
    this.appA3DocService.getDocumentsWithoutPayrollForHrUser(0, this.companySelected, false)
      .then((result) => {
        this.loading = false;
        this.allDocuments = result; // Guarda los datos originales
        this.dataSource = result;   // Inicialmente muestra todos los datos
      })
      .catch((error) => {
        this.loading = false;
        console.error('Error al obtener los documentos:', error);
      });
  }

  onOptionChanged(event: any) {
    if (event.fullName === "columns[2].filterValues" && event.value) {
      this.selectedHeaderFilter = event.value;
      this.applyLocalFilter(); // Llama al método para aplicar el filtro localmente
    } else if (event.fullName === "columns[2].filterValues" && !event.value) {
      this.selectedHeaderFilter = []; // Limpia el filtro si no hay valores seleccionados
      this.applyLocalFilter();
    }

  }

  applyLocalFilter() {
    if (this.selectedHeaderFilter.length > 0) {

      // Filtra `allDocuments` en base a `selectedHeaderFilter`
      this.dataSource = this.allDocuments.filter((item) => {

        const hasMatch = item.containersNames?.some((category: string) => {

          const match = this.selectedHeaderFilter.some((filterValue) => {
            // console.log(`Comparando "${category}" con filtro "${filterValue}"`);
            return category.toLowerCase().includes(String(filterValue).toLowerCase()); // Aseguramos que `filterValue` sea una cadena
          });

          // console.log(`¿Coincide alguna categoría con los filtros? ${match}`);
          return match;
        });

        return hasMatch;
      });

      // console.log('Documentos después de aplicar filtro:', this.dataSource[0]);
      this.dataSource = [this.dataSource[0]];
    } else {
      this.dataSource = [...this.allDocuments];
    }

    // Forzar detección de cambios
    this.cdr.detectChanges();
  }

  updateSelectedRows(e) {
    this.selectedRows = e.selectedRowsData;
  }

  getRawDate(data: any): Date {
    return new Date(data.createdAt); // Devuelve el objeto Date para el ordenamiento
  }

  getFormattedDate(data: any): string {
    const date = new Date(data.createdAt);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son de 0-11 en JavaScript
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  formatDateText(cellInfo: any): string {

    const date = new Date(cellInfo); // Aquí el valor es el timestamp o el ISO string original
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses 0-11
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; // Formato dd/MM/yyyy
  }


  onDeleteDoc(data: any) {

    this._messageDialog.ShowQuestion(

      `Se eliminará ${data.data.title}`,
      'Eliminar documento'
    )
      .then(result => {
        if (result.value) {

          this.dataGrid.instance.beginCustomLoading('');

          this.appA3DocService.deleteDoc(data.data.id).then(
            response => {
              if (response.errorCode === 0) {
                this.dataSource = this.dataSource.filter(item => item.id !== data.data.id);
                this.dataGrid.instance.endCustomLoading()
              } else {
                this._messageDialog.ShowAlert(
                  `Error al eliminar ${data.data.title}`,
                  `Se ha producido un error al eliminar ${data.data.title} `
                );
                console.error('An error occurred:', response);
              }
            },
            error => {
              this._messageDialog.ShowAlert(
                `Error al eliminar ${data.data.title}`,
                `Se ha producido un error al eliminar ${data.data.title} `
              );
              console.error('An error occurred:', error);
            }
          );
        }
      });
  }

  onEditDocument(data: any) {
    this._router.navigate([data.data.id], { state: { data: data.data }, relativeTo: this._activatedRoute });
  }






}
